import React from 'react';
import { Resizable } from 'react-resizable';
import 'react-resizable/css/styles.css';

interface ResizableTitleProps extends React.ThHTMLAttributes<HTMLTableHeaderCellElement> {
  width?: number;
  minWidth?: number;
  maxWidth?: number;
  onResize?: (e: React.SyntheticEvent<Element>, data: { size: { width: number } }) => void;
}

const ResizableTitle: React.FC<ResizableTitleProps> = (props) => {
  const { width, minWidth, maxWidth, onResize, ...restProps } = props;
  if (!width) {
    return <th {...restProps} />;
  }

  // Type workaround: cast to a generic component to satisfy JSX in TS
  const AnyResizable = Resizable as unknown as React.ComponentType<any>;

  return (
    <AnyResizable
      width={width}
      height={0}
      onResize={onResize}
      minConstraints={[typeof minWidth === 'number' ? minWidth : 40, 0]}
      maxConstraints={[typeof maxWidth === 'number' ? maxWidth : Math.max(2000, (width || 150) * 4), 0]}
      draggableOpts={{ enableUserSelectHack: false }}
    >
      {/* Ensure header title renders via children */}
      <th {...restProps} style={{ ...(restProps.style || {}), width }}>{(restProps as any).children}</th>
    </AnyResizable>
  );
};

export default ResizableTitle;
